import { Gauge } from "lucide-react";
import { C, confidenceTone, DM, UI } from "./ui-tokens";

export type LevelChipState = "assigned" | "band" | "default";

/** Pill rendering a level token. `assigned` = solid ink (the anchored level),
 *  `band` = red-tinted (inside the estimate band), `default` = hollow. */
export function LevelChip({
  level,
  state = "default",
  size = "md",
}: {
  level: string;
  state?: LevelChipState;
  size?: "md" | "lg";
}) {
  const padding = size === "lg" ? "6px 12px" : "3px 9px";
  const fontSize = size === "lg" ? 15 : 12;
  let bg: string = "transparent";
  let fg: string = C.ink50;
  let border = `1px solid ${C.ink10}`;
  let fontWeight = 600;
  if (state === "assigned") {
    bg = C.ink;
    fg = C.white;
    border = `1px solid ${C.ink}`;
    fontWeight = 700;
  } else if (state === "band") {
    bg = C.red10;
    fg = C.red;
    border = `1px solid ${C.red20}`;
  }
  return (
    <span
      style={{
        ...DM,
        fontWeight,
        fontSize,
        padding,
        borderRadius: 999,
        background: bg,
        color: fg,
        border,
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
      }}
    >
      {level}
    </span>
  );
}

/** Confidence chip — tone keyed off the 60%/75% buckets. `value` is 0–1. */
export function ConfChip({ value, small = false }: { value: number; small?: boolean }) {
  const t = confidenceTone(value);
  return (
    <span
      style={{
        ...UI,
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontWeight: 600,
        fontSize: small ? 11 : 12,
        padding: small ? "2px 8px" : "3px 10px",
        borderRadius: 999,
        background: t.bg,
        color: t.fg,
      }}
    >
      <Gauge size={small ? 12 : 14} /> {Math.round(value * 100)}%
    </span>
  );
}
